module.exports = __webpack_public_path__ + "img/10_7.e64e5d2b.png";